export default __webpack_public_path__ + "static/media/audio-file-white.b9da44b7.svg";